import React from 'react';

interface BlogNavigationProps {
  blogUrl: string;
  children: React.ReactNode;
}

export const BlogNavigation: React.FC<BlogNavigationProps> = ({ blogUrl, children }) => {
  const handleNavigation = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.location.href = blogUrl;
  };

  return (
    <a
      href={blogUrl}
      onClick={handleNavigation}
      className="inline-block"
    >
      {children}
    </a>
  );
};